import { IPersonConfig } from "@core/services/interfaces/geral/person/IPersonService";

const personConfig: IPersonConfig = {
  // Endpoints
  validCpfCnpjPersonEndpoint: "/api/Geral/Pessoa/Documento",
};

export default personConfig;
